// Single source of truth for breakpoint pixel values. Imported by tailwind.config.ts (so these are the actual CSS breakpoints) and by any JS that needs to match a breakpoint outside of CSS (e.g. an <img> `sizes` attribute) — safe to import from client components since this file has no dependencies of its own.
export const tailwindTheme = {
  screens: {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px",
  },
} as const;
